export const addLab = async (data, token) => {
  try {
    const response = await fetch(
      'https://api-dhct-int-qa-app.carenow.healthcare/dhct/report/docs/upload',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify(data)
      }
    )

    const responseJson = await response.json()

    if (response.ok || responseJson?.statusCode?.toString().startsWith('2')) {
      return { success: true, data: responseJson }
    } else {
      return { success: false, error: responseJson }
    }
  } catch (error) {
    return { success: false, error }
  }
}

export const getLab = async (
  data,
  token = localStorage.getItem('dr_token')
) => {
  try {
    const getResponse = await fetch(
      'https://api-dhct-int-qa-app.carenow.healthcare/dhct/report/docs/list',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify(data)
      }
    )

    const responseJson = await getResponse.json()
    return {
      success: getResponse.ok,
      data: responseJson
    }
  } catch (error) {
    console.error('Error in getLab:', error)
    return {
      success: false,
      error
    }
  }
}

export const downloadFile = async presigned_uri => {
  try {
    const pd_id = localStorage.getItem('pd_id')
    const token = localStorage.getItem('dr_token')

    const response = await fetch(
      'https://api-dhct-int-qa-app.carenow.healthcare/dhct/report/docs/view',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          pd_id,
          presigned_uri
        })
      }
    )
    const result = await response.json()

    if (result.statusCode === 200 && result.body) {
      const fileResponse = await fetch(result.body)
      const blob = await fileResponse.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const filename =
        result.body.split('/').pop().split('?')[0] || 'document.pdf'
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } else {
      console.error(result.message || 'Failed to fetch download URL.')
    }
  } catch (error) {
    console.error('Download error:', error)
  }
}

export const getPresignedURL = async presigned_uri => {
  try {
    const pd_id = localStorage.getItem('pd_id')
    const token = localStorage.getItem('dr_token')

    const response = await fetch(
      'https://api-dhct-int-qa-app.carenow.healthcare/dhct/report/docs/view',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          pd_id,
          presigned_uri
        })
      }
    )

    const result = await response.json()
    console.log('Presigned URL response:', result)

    if (result.statusCode === 200 && result.body) {
      return result.body
    } else {
      console.error(result.message || 'Failed to fetch presigned URL.')
      return null
    }
  } catch (error) {
    console.error('Presigned URL error:', error)
    return null
  }
}
